import React from 'react'
import debounce from 'debounce'
import { CustomerText, ProgressStatusFun, HeaderDataFun } from '../CustomerText'
import { GetCategories, GetQuestionTypes, GetHotTopics } from './../Api'
import Config from '../Config'
const { Language, platform, OpenLiveChat, Router, ModalTip, GLOBAL, getRouterType, ToastTip, Pushgtagpiwikurl, Pushgtagdata } = Config()
const { Info, Confirm } = ModalTip

const tempText = CustomerText[Language]
const HeaderData = HeaderDataFun(Language)
const ProgressStatus = ProgressStatusFun(Language)

const questionTypesListAll = {
    questionType: CustomerText[Language]?.text49,
    questionTypeID: ''
}


export default class Components extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            headerIndex: 0,

            hotTopics: [],
            categories: [],
            questionTypes: [],
            questionTypesAll: [],



            routerName: 'index',
            tempCategories: {
                categoryName: '',
                articles: []
            },
            knowledgeBaseID: '',
            isAllowFeedBackLeave: false,

            isShowSearchQuestion: false,
            detailRandom: Math.random(),
            token: '',
            isLogin: false,
            isUserLogin: Config()?.isUserLogin,


            scrollTop: 0,

        }
        this.scrollRef = React.createRef();
        this.handleScroll = debounce(this.handleScroll.bind(this), 10) // 300ms 的延迟
    }

    async componentDidMount() {

        this.handleMessage()



        if (getRouterType() == 'history') {
            this.setState({
                headerIndex: 1,
                routerName: 'history'
            })
        }
        this.setState({
            isUserLogin: Config()?.isUserLogin
        })

        let tempHotTopics = []
        let tempCategories = []
        let tempQuestionTypes = []
        try {
            tempHotTopics = GLOBAL?.JSON?.parse(GLOBAL?.localStorage?.getItem(Language + '-hotTopics')) || []
            tempCategories = GLOBAL?.JSON?.parse(GLOBAL?.localStorage?.getItem(Language + '-categories')) || []
            tempQuestionTypes = GLOBAL?.JSON?.parse(GLOBAL?.localStorage?.getItem(Language + '-questionTypes')) || []
            this.setState({
                hotTopics: tempHotTopics,
                categories: tempCategories,
                questionTypes: tempQuestionTypes,
                questionTypesAll: [questionTypesListAll, ...tempQuestionTypes]
            })
            if (!((Array.isArray(tempHotTopics) && tempHotTopics.length > 0) && (Array.isArray(tempCategories) && tempCategories.length > 0) && (Array.isArray(tempQuestionTypes) && tempQuestionTypes.length > 0))) {
                ToastTip.loading(tempText?.text70)
            }
        } catch (err) {
            ToastTip.loading(tempText?.text70)
        }

        let data = await Promise.all([
            GetHotTopics(),
            GetCategories(),
            GetQuestionTypes()
        ]) || [[], [], []]
        ToastTip.hide()
        let [hotTopics, categories, questionTypes] = data

        this.setState({
            hotTopics,
            categories,
            questionTypes,
            questionTypesAll: [questionTypesListAll, ...questionTypes]
        }, () => {
            if (platform == 'Web' && Array.isArray(categories) && categories.length) {
                this.RouterDetail({
                    type: 'general',
                    tempData: categories[0],
                    isChangeIndex: true
                })
            }
        })

        GLOBAL?.localStorage?.setItem(Language + '-hotTopics', GLOBAL.JSON.stringify(hotTopics))
        GLOBAL?.localStorage?.setItem(Language + '-categories', GLOBAL.JSON.stringify(categories))
        GLOBAL?.localStorage?.setItem(Language + '-questionTypes', GLOBAL.JSON.stringify(questionTypes))

        this.scrollRef?.current?.addEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState?.routerName !== this.state?.routerName && platform == 'Mobile') {
            this.setState({
                scrollTop: 0
            }, () => {
                try {
                    if (this?.scrollRef && this?.scrollRef?.current) {
                        this.scrollRef.current.scrollTop = 0
                    }
                } catch (err) {

                }
            })
        } else {
            return false
        }

    }

    handleScroll = () => {
        let { routerName } = this.state
        if ((routerName == 'history' || routerName == 'index') && platform == 'Mobile') {
            return
        }
        this.setState({
            scrollTop: this.scrollRef?.current?.scrollTop
        })
    };

    handleMessage = (event) => {
        const urlParams = new URLSearchParams(window.location.search)
        const userName = urlParams.get('userName') || ''
        const token = urlParams.get('token') || ''
        const isFrom = urlParams.get('isFrom') || ''
        if (platform == 'Mobile') {
            if (typeof isFrom == 'string' && isFrom == 'app') {
                GLOBAL?.localStorage?.setItem("fromApp", "1");

                if (typeof token == 'string' && token.length) {
                    GLOBAL?.localStorage?.setItem('memberToken', GLOBAL?.JSON?.stringify(token));
                    GLOBAL?.localStorage?.setItem("loginStatus", "1");
                    GLOBAL?.localStorage?.setItem("userNameApp", userName);
                    this.setState({
                        token: GLOBAL?.JSON?.parse(localStorage.getItem('memberToken')),
                        isUserLogin: true
                    })
                } else {
                    GLOBAL?.localStorage?.removeItem('memberToken')
                    GLOBAL?.localStorage?.removeItem('loginStatus')
                    GLOBAL?.localStorage?.removeItem('userNameApp')
                    this.setState({
                        token: '',
                        isUserLogin: false
                    })
                }
            } else {
                this.setState({
                    isUserLogin: Config()?.isUserLogin
                })
            }
        } else {
            this.setState({
                isUserLogin: Config()?.isUserLogin
            })
        }
        return
        // const json = event?.data;
        // try {
        //     let message = JSON.parse(json) || {}
        //     let { isFrom = '', token = '' } = message
        //     GLOBAL?.localStorage?.setItem("fromApp", "1");
        //     if (token) {
        //         GLOBAL?.localStorage?.setItem('memberToken', GLOBAL?.JSON?.stringify('Bearer ' + token));
        //         GLOBAL?.localStorage?.setItem("loginStatus", "1");
        //         this.setState({
        //             token: GLOBAL?.JSON?.parse(localStorage.getItem('memberToken')),
        //             isUserLogin: GLOBAL?.localStorage?.getItem("loginStatus") == 1 || Config()?.isUserLogin
        //         })
        //     }

        // } catch (e) {}
    };




    changeTabIndex(headerIndex) {
        let { questionTypes } = this.state
        if (!(Array.isArray(questionTypes) && questionTypes.length)) return
        this.setState({
            headerIndex,
            routerName: headerIndex ? 'history' : 'index'
        })

        Pushgtagpiwikurl('help_center', 'Help Center')
        headerIndex == 0 ? Pushgtagdata('HelpCenter', 'View FAQ', 'HelpCenter_C_FAQ') : Pushgtagdata('HelpCenter', 'View FeedbackRecord', 'HelpCenter_C_Record')
    }

    RouterFeedback({ fromPage = '' }) {
        let { isUserLogin } = this.state
        if (!isUserLogin) {
            Info({
                title: tempText?.text65,
                children: tempText?.text68,
                isShowCloseBtn: true,
                okBtnTxt: tempText?.text69,
                okFunction: () => {
                    Router({
                        routerName: 'Login'
                    })
                }
            })

            Pushgtagpiwikurl('help_center_login_popup', 'Help Center Login Popup')
            Pushgtagdata('HelpCenter', 'Go to Login', 'HelpCenter_LoginPopup_C_Login')
            return
        }
        let { questionTypes } = this.state
        if (!(Array.isArray(questionTypes) && questionTypes.length)) return
        this.setState({
            routerName: 'Feedback',
        })

        if (fromPage == 'Question') {
            Pushgtagpiwikurl('help_center', 'Help Center')
            Pushgtagdata('HelpCenter', 'Give Feedback', 'HelpCenter_C_GiveFeedback')
        } else if (fromPage == 'QuestionDetail') {
            Pushgtagpiwikurl('help_center', 'Help Center')
            Pushgtagdata('HelpCenter', 'Give Feedback', 'HelpCenter_FAQ_C_GiveFeedback')
        } else if (fromPage == 'Record') {
            Pushgtagpiwikurl('help_center_feedback_record', 'Help Center Feedback Record')
            Pushgtagdata('HelpCenter', 'Give Feedback', 'HelpCenter_Record_C_GiveFeedback')
        }
    }

    RouterSearch(routerName = 'Search') {
        this.setState({
            routerName,
        })
    }

    RouterLogin() {
        Router({
            routerName: 'Login',
        })

        Pushgtagpiwikurl('help_center_login_popup', 'Help Center Login Popup')
        Pushgtagdata('HelpCenter', 'Go to Login', 'HelpCenter_Record_C_Login')
    }

    RouterDetail({ type = '', piwikType = '', piwikTitle = '', tempData = {}, routerName = 'QuestionDetail', isChangeIndex = false }) {
        if (piwikType == 'hot') {
            Pushgtagpiwikurl('help_center', 'Help Center')
            Pushgtagdata('HelpCenter', 'View Hot Question', 'HelpCenter_C_HotQuestion', false,
                [
                    {
                        customVariableKey: "HelpCenter_C_HotQuestionTitle",
                        customVariableValue: tempData?.title
                    }
                ]
            )
        } else if (piwikType == 'general') {
            Pushgtagpiwikurl('help_center', 'Help Center')
            Pushgtagdata('HelpCenter', 'View FAQ Content', 'HelpCenter_C_FAQContent', false,
                [
                    {
                        customVariableKey: "HelpCenter_C_FAQContentTitle",
                        customVariableValue: tempData?.categoryName || piwikTitle
                    }
                ]
            )
        }
        if (routerName.includes('knowledgeBaseID') || (type == '' && Object.keys(tempData).length <= 0)) {
            this.setState({
                routerName,
            })
            return
        }
        this.toggleSearchQuestion(false)
        let tempCategories = tempData
        let knowledgeBaseID = ''

        let { categories } = this.state
        if (type == 'hot') {
            let { categories } = this.state
            tempCategories = categories.find(v1 => Array.isArray(v1?.articles) && v1?.articles.length && v1?.articles.find(v2 => v2?.knowledgeBaseID == tempData?.knowledgeBaseID))
            knowledgeBaseID = tempData?.knowledgeBaseID
        }

        categories.forEach(v => {
            let articles = v.articles
            if (Array.isArray(articles) && articles.length) {
                articles.forEach(v2 => {
                    v2.isShow = false
                })
            }
        })

        this.setState({
            routerName: type == 'hot' ? `QuestionDetail/isBackPage` : routerName,
            tempCategories,
            knowledgeBaseID,
            headerIndex: isChangeIndex ? this.state.headerIndex : 0,
            detailRandom: platform == 'Web' && Math.random()
        })

    }


    toggleSearchQuestion(isShowSearchQuestion) {
        if (platform == 'Web') {
            this.setState({
                isShowSearchQuestion,
                headerIndex: 0
            })
            setTimeout(() => {
                let dom = GLOBAL.document.getElementsByClassName('serachInputWrap')[0]
                if (dom) {
                    dom.style.top = isShowSearchQuestion ? '-133px' : '-225px'  // 直接设置样式
                    dom.style.setProperty('top', isShowSearchQuestion ? '-133px' : '-225px', 'important');
                }
            }, 0)
        }
    }


    getTitle(routerName) {
        if (routerName == 'index' || routerName == 'history') {
            return tempText?.text1
        } else if (routerName.includes('QuestionDetail') && !routerName.includes('Search')) {
            let { tempCategories } = this.state
            return tempCategories?.categoryName
        } else if (routerName.includes('Search')) {
            return tempText?.text37
        } else if (routerName == 'Feedback') {
            return tempText?.text8
        }
    }

    onLeft(routerName) {
        if (routerName == 'index' || routerName == 'history') {
            Router({
                routerName: 'pop',
            })
        } else if (routerName.includes('QuestionDetail') && !routerName.includes('Search')) {
            if (routerName.includes('isBackPage')) {
                this.setState({
                    routerName: 'QuestionDetail'
                })
            } else {
                this.setState({
                    routerName: 'index'
                })
            }
        } else if (routerName.includes('Search')) {
            if (platform == 'Web') { // web 从ai页面回退 
                this.setState({
                    isShowSearchQuestion: false,
                    headerIndex: 0
                })
                return
            }
            if (routerName.includes('isBackPage')) {
                this.setState({
                    routerName: 'Search',
                    detailRandom: Math.random(),
                })
            } if (routerName.includes('QuestionDetail')) {
                this.setState({
                    routerName: 'QuestionDetail'
                })
            } else {
                this.setState({
                    routerName: 'index'
                })
            }
        } else if (routerName == 'Feedback') {
            this.onFeedbackBack({
                isAllowFeedBackLeave: this.state.isAllowFeedBackLeave,
                callBack: () => {
                    this.setState({
                        routerName: 'index'
                    })
                }
            })
        }
    }

    getFeedBackLeaveStatus({ isAllowFeedBackLeave, type = '' }) {
        this.setState({
            isAllowFeedBackLeave
        }, () => {
            if (type == 'submit') {
                this.onLeft('Feedback')
                this.setState({
                    headerIndex: 1
                })
            }
        })
    }

    onFeedbackBack({ isAllowFeedBackLeave, callBack = () => { } }) {
        if (isAllowFeedBackLeave) {
            Confirm({
                title: tempText?.text29,
                children: tempText?.text30,
                noBtnTxt: tempText?.text31,
                noFunction: () => {
                    callBack()
                },
                okBtnTxt: tempText?.text32,
                okFunction: () => {

                }
            })

            Pushgtagpiwikurl('help_center_leave_give_feedback_popup', 'Help Center Leave Give Feedback')
        } else {
            callBack()
        }
    }

    render() {
        const { Header, Tabs, LiveChat, QuestionTop, QuestionBottom, Record, QuestionDetail, Feedback, Search, Tag } = this.props
        let {
            headerIndex, hotTopics, categories, questionTypesAll,
            routerName,
            tempCategories,
            knowledgeBaseID,
            questionTypes,
            isShowSearchQuestion,
            detailRandom,
            isUserLogin,
            scrollTop
        } = this.state
        return <>
            {
                platform == 'Web'
                    ?
                    <>
                        <QuestionTop
                            hotTopics={hotTopics}
                            categories={categories}
                            RouterSearch={this.RouterSearch.bind(this)}
                            RouterFeedback={this.RouterFeedback.bind(this)}
                            RouterDetail={this.RouterDetail.bind(this)}
                        ></QuestionTop>

                        {
                            routerName == 'Feedback' &&
                            <Feedback
                                questionTypes={questionTypes}
                                onLeft={this.onLeft.bind(this)}
                                getFeedBackLeaveStatus={this.getFeedBackLeaveStatus.bind(this)}
                            ></Feedback>
                        }


                        {
                            !isShowSearchQuestion &&
                            <Tabs
                                headerData={HeaderData}
                                headerIndex={headerIndex}
                                onClick={this.changeTabIndex.bind(this)}
                            ></Tabs>
                        }

                        {

                            <Tag className={'tabContainers'}>
                                <Search
                                    className={(isShowSearchQuestion && headerIndex == 0) ? 'searchShow' : 'searchHide'}
                                    type='bottom'
                                    RouterDetail={this.RouterDetail.bind(this)}
                                    onLeft={this.onLeft.bind(this)}
                                    toggleSearchQuestion={this.toggleSearchQuestion.bind(this)}
                                ></Search>

                                {
                                    headerIndex == 0
                                        ?
                                        (
                                            !isShowSearchQuestion
                                                ?
                                                <Tag className="question-wrap">
                                                    {
                                                        Array.isArray(categories) && !!categories.length &&
                                                        <QuestionBottom
                                                            hotTopics={hotTopics}
                                                            categories={categories}
                                                            RouterSearch={this.RouterSearch.bind(this)}
                                                            RouterFeedback={this.RouterFeedback.bind(this)}
                                                            RouterDetail={this.RouterDetail.bind(this)}
                                                            tempCategories={tempCategories}
                                                        ></QuestionBottom>
                                                    }

                                                    <QuestionDetail
                                                        key={detailRandom}
                                                        knowledgeBaseID={knowledgeBaseID}
                                                        tempCategories={tempCategories}
                                                        categories={categories}
                                                        RouterFeedback={this.RouterFeedback.bind(this)}
                                                        onLeft={this.onLeft.bind(this)}
                                                        RouterSearch={this.RouterSearch.bind(this)}
                                                    ></QuestionDetail>
                                                </Tag>
                                                :
                                                null
                                        )
                                        :
                                        <Record
                                            isUserLogin={isUserLogin}
                                            questionTypes={questionTypesAll}
                                            RouterLogin={this.RouterLogin.bind(this)}
                                            RouterFeedback={this.RouterFeedback.bind(this)}
                                            OpenLiveChat={OpenLiveChat}
                                            ProgressStatus={ProgressStatus}

                                            Info={Info}
                                        ></Record>
                                }
                            </Tag>
                        }

                    </>
                    :
                    <>
                        {
                            //!(routerName.includes('Search') && routerName.includes('QuestionDetail')) &&
                            <Header
                                className={(routerName == 'index' || routerName == 'history') ? 'hide' : ''}
                                tempText={tempText}
                                title={this.getTitle(routerName)}
                                RouterSearch={this.RouterSearch.bind(this)}
                                isShowArrow={(routerName.includes('QuestionDetail/isBackPage')) && scrollTop >= 20}
                                isShowHeaderBar={(routerName.includes('QuestionDetail/isBackPage')) ? (scrollTop <= 20) : true}
                                isShowSearchBar={routerName == 'QuestionDetail' || ((routerName.includes('QuestionDetail/isBackPage')) ? (scrollTop == 0 || scrollTop >= 20) : false)}
                                onLeft={this.onLeft.bind(this, routerName)}
                            ></Header>
                        }

                        {
                            (routerName == 'index' || routerName == 'history') &&
                            <Tabs
                                headerData={HeaderData}
                                headerIndex={headerIndex}
                                onClick={this.changeTabIndex.bind(this)}
                            ></Tabs>
                        }

                        <Tag
                            ref={this.scrollRef}
                            className={`${routerName.includes('Search') ? '' : 'scroll'} ${routerName.includes('QuestionDetail') && !routerName.includes('Search') ? 'QuestionDetail' : ''}`}
                        >
                            {
                                (routerName == 'index' || routerName == 'history')
                                    ?
                                    <>
                                        {
                                            headerIndex == 0
                                                ?
                                                <>
                                                    <QuestionTop
                                                        hotTopics={hotTopics}
                                                        categories={categories}

                                                        RouterSearch={this.RouterSearch.bind(this)}
                                                        RouterFeedback={this.RouterFeedback.bind(this)}
                                                        RouterDetail={this.RouterDetail.bind(this)}
                                                    ></QuestionTop>
                                                    <QuestionBottom
                                                        hotTopics={hotTopics}
                                                        categories={categories}

                                                        RouterSearch={this.RouterSearch.bind(this)}
                                                        RouterFeedback={this.RouterFeedback.bind(this)}
                                                        RouterDetail={this.RouterDetail.bind(this)}
                                                    ></QuestionBottom>
                                                </>
                                                :
                                                <Record
                                                    isUserLogin={isUserLogin}
                                                    questionTypes={questionTypesAll}
                                                    RouterLogin={this.RouterLogin.bind(this)}
                                                    RouterFeedback={this.RouterFeedback.bind(this)}
                                                    OpenLiveChat={OpenLiveChat}
                                                    ProgressStatus={ProgressStatus}
                                                    key={headerIndex}
                                                    Info={Info}
                                                ></Record>
                                        }
                                    </>
                                    :
                                    <>
                                        {
                                            routerName.includes('Search') &&
                                            <Search
                                                key={detailRandom}
                                                toggleSearchQuestion={this.toggleSearchQuestion.bind(this)}
                                                onLeft={this.onLeft.bind(this)}
                                                RouterSearch={this.RouterSearch.bind(this)}
                                                routerName={routerName}
                                            ></Search>
                                        }

                                        {
                                            routerName.includes('QuestionDetail') && !routerName.includes('Search') &&
                                            <QuestionDetail
                                                categories={categories}
                                                routerName={routerName}
                                                knowledgeBaseID={knowledgeBaseID}
                                                tempCategories={tempCategories}
                                                RouterFeedback={this.RouterFeedback.bind(this)}
                                                onLeft={this.onLeft.bind(this)}
                                                RouterDetail={this.RouterDetail.bind(this)}
                                                toggleSearchQuestion={this.toggleSearchQuestion.bind(this)}
                                                RouterSearch={this.RouterSearch.bind(this)}
                                            ></QuestionDetail>
                                        }

                                        {
                                            routerName == 'Feedback' &&
                                            <Feedback
                                                questionTypes={questionTypes}
                                                getFeedBackLeaveStatus={this.getFeedBackLeaveStatus.bind(this)}
                                            ></Feedback>
                                        }
                                    </>

                            }
                        </Tag>
                    </>
            }

            <LiveChat OpenLiveChat={OpenLiveChat} className={routerName == 'history' ? 'hide' : 'home'}></LiveChat>
        </>
    }
}